import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import CodeContent from './CodeContent';
import TablaDocs from './TablaDocs';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

function TablaDoc(
    Descripcion,
   Detalles
) {
  return { Descripcion,Detalles };
}

const DocExcelWord = () => {
  const [t] = useTranslation('global');

 
  
  return (
    <div id='calculos'>
      <Divider sx={{ height: '70px' } } />
      <Typography variant="h3" gutterBottom>
        {t('content.DocumentosCalculoTablas.titulo')}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('content.DocumentosCalculoTablas.descripcion')}
      </Typography>
      <br></br>
      <List>
        <ListItem>
          {/*<ListItemText primary={t('content.DocumentosCalculoTablas.Doc1')} />*/}
          
          <a href={'/content/Docs/FORMULAS COMPROBANTES VERSION 12 XML - PARA INTEGRACION BASICA.xlsx'} download style={{ color: '#3cacdc ' }} >
          {t('content.DocumentosCalculoTablas.Doc1')}
          </a>
        </ListItem>
        <ListItem>
        <a href={'/content/Docs/GUIA DE USO FORMULA DE COMPROBANTES.pdf'} download style={{ color: '#3cacdc ' }}>
          {t('content.DocumentosCalculoTablas.Doc2')}
          </a>
        </ListItem>
        <ListItem>
        <a href={'/content/Docs/AjustesValidacionesCPEv20230317.xlsx'} download style={{ color: '#3cacdc ' }}>
          {t('content.DocumentosCalculoTablas.Doc3')}
          </a>
        </ListItem>
      </List>
    </div>
  );
}

export default DocExcelWord